'use client';

import { ArrowLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import Button from '@/ui/Button';
import AdsterraBanner from '@/components/AdsterraBanner';

export default function TermsPage() {
  const router = useRouter();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Button
          variant="ghost"
          onClick={() => router.back()}
          className="mb-8 flex items-center gap-2"
        >
          <ArrowLeft size={20} />
          Back
        </Button>

        <div className="mb-12">
          <h1 className="text-5xl sm:text-6xl font-bold text-foreground mb-4">
            Terms of Service
          </h1>
          <p className="text-muted">
            Last updated: November 2024
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <AdsterraBanner position="top" />

        <div className="bg-card-bg border border-border rounded-2xl p-8 sm:p-12
          space-y-8">
          {/* Section 1 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              1. Agreement to Terms
            </h2>
            <p className="text-foreground/80 leading-relaxed">
              By accessing and using Minifictionverse, you agree to these Terms
              of Service. If you do not agree, please do not use this service.
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              2. Use License
            </h2>
            <p className="text-foreground/80 leading-relaxed mb-4">
              You are granted a limited license to access and read stories on
              Minifictionverse for personal, non-commercial use only. You may not:
            </p>
            <ul className="list-disc list-inside space-y-2 text-foreground/80">
              <li>Copy, modify, or reproduce any content</li>
              <li>Use content for commercial purposes</li>
              <li>Attempt to bypass security measures</li>
              <li>Remove copyright or proprietary notices</li>
              <li>Redistribute or mirror content on other servers</li>
            </ul>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              3. Content Disclaimer
            </h2>
            <p className="text-foreground/80 leading-relaxed">
              Minifictionverse provides content &quot;as is&quot; without warranties.
              We do not guarantee accuracy, completeness, or fitness for any
              particular purpose. Content may change without notice.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              4. Limitation of Liability
            </h2>
            <p className="text-foreground/80 leading-relaxed">
              Minifictionverse is not liable for any damages arising from your use
              of the platform, including loss of data or business interruption.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              5. User Conduct
            </h2>
            <p className="text-foreground/80 leading-relaxed mb-4">
              You agree to use Minifictionverse responsibly:
            </p>
            <ul className="list-disc list-inside space-y-2 text-foreground/80">
              <li>Do not engage in illegal activities</li>
              <li>Do not harass or abuse other users</li>
              <li>Do not spam or post malicious content</li>
              <li>Respect intellectual property rights</li>
            </ul>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              6. Changes to Terms
            </h2>
            <p className="text-foreground/80 leading-relaxed">
              Minifictionverse may update these terms at any time. Continued use
              of the platform means you accept the updated terms.
            </p>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">
              7. Contact
            </h2>
            <p className="text-foreground/80 leading-relaxed mb-4">
              For questions about these Terms of Service:
            </p>
            <div className="p-4 bg-background rounded-lg">
              <p className="text-foreground/70">
                Email: helpdesk@minifanfictionverse.site
              </p>
            </div>
          </section>
        </div>

        <AdsterraBanner position="bottom" />
      </div>
    </div>
  );
}
